/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popUpGold.vue?vue&type=template&id=a6b1c0e6&scoped=true"
import script from "./popUpGold.vue?vue&type=script&lang=js"
export * from "./popUpGold.vue?vue&type=script&lang=js"
import style0 from "./popUpGold.vue?vue&type=style&index=0&id=a6b1c0e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b1c0e6",
  null
  
)

export default component.exports